import { DisclaimerApi, DisclaimerItemDto } from "../../../@api";

import { LanguageOptionsEnum } from "../../models/constants/app-language-options.const";
import { TDisclaimer } from "../../models/types/disclaimer.type";
import { IStoreContext } from "../../stores/StoreContext";
import { DisclaimerApiService } from "../ApiServices/DisclaimerApiService";
import GenericService from "../GenericService";

export class DisclaimerService extends GenericService<DisclaimerApi, DisclaimerApiService> {
  constructor(storeContext: IStoreContext) {
    super(storeContext, DisclaimerApi, DisclaimerApiService);
  }

  public getDisclaimerText(translationKey: LanguageOptionsEnum, type: TDisclaimer): Promise<DisclaimerItemDto> {
    return this.apiService.disclaimerGet({
      type: type,
      language: translationKey,
    });
  }

  public async putDisclaimerTexts(disclaimerItemDto: DisclaimerItemDto): Promise<DisclaimerItemDto> {
    return this.apiService.disclaimerPut({ disclaimerItemDto });
  }

  public async putDisclaimerTextsBulk(disclaimerItemDto: Array<DisclaimerItemDto>): Promise<Array<DisclaimerItemDto>> {
    return this.apiService.disclaimerPutBulk({ disclaimerItemDto });
  }

  public async getDisclaimerTexts(type: TDisclaimer): Promise<Array<DisclaimerItemDto>> {
    return this.apiService.disclaimerGetAll({ type });
  }
}
